import isDev from '../../isDev/index.js';

var Logger = function () {
  function Logger() {}
  Logger.info = function (message, style) {
    isDev && console.info(message, style);
  };
  Logger.success = function (message) {
    isDev && console.log("%c ".concat(message), 'color:green');
  };
  Logger.error = function (message) {
    isDev && console.trace(message);
  };
  Logger.warn = function (message) {
    isDev && console.warn(message);
  };
  Logger.deprecate = function (message) {
    isDev && console.warn('DEPRECATION::: ', message);
  };
  return Logger;
}();

export { Logger as default };
//# sourceMappingURL=index.js.map
